import { supabase } from '../lib/supabase/client';

export interface TransbankInitResult {
  url: string;
  token: string;
  pago_id: string;
}

export class TransbankService {
  static async initAnticipo(consultaId: string): Promise<TransbankInitResult> {
    const { data, error } = await supabase.functions.invoke('transbank', {
      body: { action: 'init-anticipo', consulta_id: consultaId },
    });
    if (error) {
      // Extraer error real del body de la Edge Function (no el genérico de supabase-js)
      try {
        const body = await (error as any).context?.json?.();
        if (body?.error) throw new Error(body.error);
      } catch (inner) {
        if (inner instanceof Error && inner.message !== error.message) throw inner;
      }
      throw new Error(error.message);
    }
    if (data?.error) throw new Error(data.error);
    return data;
  }

  static async initSaldo(consultaId: string): Promise<TransbankInitResult> {
    const { data, error } = await supabase.functions.invoke('transbank', {
      body: { action: 'init-saldo', consulta_id: consultaId },
    });
    if (error) throw new Error(error.message);
    if (data?.error) throw new Error(data.error);
    return data;
  }

  // SEC-076: `pago_id`/`consulta_id` ya no alcanzan solo — la Edge Function
  // exige probar ownership. Vía staff (portal /panel, sesión de Supabase Auth
  // real) no hace falta pasar nada más: `functions.invoke` reenvía el JWT de
  // sesión y el Edge Function resuelve la identidad desde ahí. Vía paciente
  // (flujo anon de /agendar, sin sesión) hay que pasar `patientRut` — mismo
  // dato que ya se usa para `cancel_patient_consultation` (SEC-057).
  static async refund(
    pagoId: string,
    opts?: { patientRut?: string },
  ): Promise<{ success: boolean; tipo: string }> {
    const { data, error } = await supabase.functions.invoke('transbank', {
      body: { action: 'refund', pago_id: pagoId, p_patient_rut: opts?.patientRut },
    });
    if (error) throw new Error(error.message);
    if (data?.error) throw new Error(data.error);
    return data;
  }

  static async getPaymentStatus(consultaId: string, opts?: { patientRut?: string }) {
    const { data, error } = await supabase.functions.invoke('transbank', {
      body: { action: 'payment-status', consulta_id: consultaId, p_patient_rut: opts?.patientRut },
    });
    if (error) throw new Error(error.message);
    return data?.status ?? null;
  }

  // CRÍTICO: debe ser POST form submit, NO window.location.
  // El token expira en 5 minutos — llamar redirectToWebpay inmediatamente después de init.
  static redirectToWebpay(url: string, token: string): void {
    const form    = document.createElement('form');
    form.method   = 'POST';
    form.action   = url;
    const input   = document.createElement('input');
    input.type    = 'hidden';
    input.name    = 'token_ws';
    input.value   = token;
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  }
}
